// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "main[data-v-5c0e3fa2]{min-height:initial}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
